<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V2grC4/tc-custom/9781427859280.jpg?1703878792732" alt="This image is the cover for the book Sword Princess Amaltea, Volume 3, Sword Princess Amaltea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sword Princess Amaltea, Volume 3, Sword Princess Amaltea
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In the finale of this gender-flipped manga adventure, the adventuresome princess must prove herself worthy of the queendom—and her beautiful prince.</b></p><p> With Princess Amaltea and Prince Ossian’s feelings for one another slowly blooming into something more than just a convenient partnership, the appearance of a powerful challenger from Ossian's past threatens their future together. But Amaltea still has to prove her worthiness as a suitor and heir to the throne of the Grey Mountains queendom in a battle to the death.  </p> Has she grown enough to earn Prince Ossian's hand . . . and heart? Can the two of them find a place in a world stacked so unfairly against them? See the action-packed conclusion in Natalia Batista's gender-flipped fantasy manga with fans all around the world! 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Natalia Batista
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tokyopop Verlag
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2be8b3fa